import * as React from 'react';
import { LinkButton, SkeletonGroup, UIHeading1 } from '@cian/ui-kit';
import { useVisitedOffersContext } from '@cian/frontend-visited-offers-widget';
import { useInView } from '@cian/valuation-utils-component';
import clsx from 'clsx';

import * as styles from './RecommendationsListDesktop.css';

const SKELETON_GROUP_GAP: [string, string] = ['var(--unit_7)', 'var(--unit_5)'];

type TRecommendationsListDesktopProps = {
  showMoreLink?: boolean;
  hasSkeletons?: boolean;

  onShow?(): void;
  onMoreClick?(): void;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  afterList?: React.ReactNode;
};

export const RecommendationsListDesktop: React.FC<TRecommendationsListDesktopProps> = ({
  showMoreLink = true,
  hasSkeletons = false,

  onShow,
  children,
  onMoreClick,
  footer,
  afterList,
}) => {
  const [isShown, setIsShown] = React.useState(false);
  const { isLoaded: isVisitedOffersLoaded } = useVisitedOffersContext();

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  React.useEffect(() => {
    if (inView && onShow && !isShown && isVisitedOffersLoaded) {
      onShow();
      setIsShown(true);
    }
  }, [inView, onShow, isShown, isVisitedOffersLoaded]);

  return (
    <div ref={ref}>
      <UIHeading1>Могут подойти</UIHeading1>
      <div className={styles['list']} data-name="RecommendationsListDesktopGrid">
        <SkeletonGroup
          scope="group"
          gap={SKELETON_GROUP_GAP}
          className={clsx(styles['grid'], !hasSkeletons && styles['grid-without-skeletons'])}
        >
          <div
            className={clsx(
              styles['items'],
              hasSkeletons && React.Children.count(footer) > 0 && styles['shimmer-boundary'],
            )}
          >
            {children}
          </div>
          {footer}
        </SkeletonGroup>
      </div>
      {afterList}
      {showMoreLink && (
        <LinkButton
          data-name="MoreLink"
          size="M"
          theme="fill_secondary"
          fullWidth
          onClick={onMoreClick}
          href="/recommendations/"
        >
          Посмотреть ещё
        </LinkButton>
      )}
    </div>
  );
};
